import { useEffect, useRef, useState } from 'react';
import cls from 'classnames';
import { useAtomValue } from 'jotai';
import { $ToastAtom } from '~/atoms/simple-toast';
import { ToastIcon } from './toast-icon';

import './style.scss';

export default function SimpleToast(): JSX.Element {
  const { content, time, iconStatus = 'default' } = useAtomValue($ToastAtom);
  const fixedWidth = iconStatus === 'default';
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setHydrated(true);
    }, 200);
  }, []);

  const [show, setShow] = useState(false);

  const timer = useRef(0);
  useEffect(() => {
    if (!content || !time) {
      return;
    }

    setShow(true);
    const newTimer = window.setTimeout(() => {
      setShow(false);
    }, 2150);
    timer.current = newTimer;

    return () => window.clearTimeout(newTimer);
  }, [content, time]);

  return (
    <div
      className={cls('simple-toast', {
        show,
        hide: !show && hydrated,
        'fixed-width': fixedWidth,
      })}
    >
      <ToastIcon />
      <p>{content || ''}</p>
    </div>
  );
}
